import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

interface ImageSlide {
  src: string;
  alt: string;
}

interface ImageCarouselProps {
  slides: ImageSlide[];
  productName?: string;
}

export const ImageCarousel = ({ slides, productName }: ImageCarouselProps) => {
  const hasSlides = slides && slides.length > 0;
  if (!hasSlides) {
    return null;
  }

  const pagination = {
    clickable: true,
    dynamicBullets: true,
  };

  return (
    <Swiper
      className="relative h-[320px] w-[300px] overflow-hidden rounded-lg
             [&_.swiper-pagination-bullet]:!size-[10px] [&_.swiper-pagination-bullet]:!bg-brand-color [&_.swiper-pagination]:!bottom-0"
      pagination={pagination}
      modules={[Pagination]}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={`${slide.src}-${index}`}>
          <img
            src={slide.src}
            alt={slide.alt || productName || "Product image"}
            className="aspect-square size-[300px] rounded-lg object-cover"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
